import React from 'react';
import { TFunction } from 'react-i18next';
import {
  Text,
  Link,
  CodeInline,
  CodeSnippet,
  Stack,
  Trans,
} from '@piwikpro/ui-components';
import { App } from '../../../model';

const PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES = {
  ANDROID: '@platform/command/appInstallation/android',
};

export const ANDROID_SNIPPET_REPOSITORIES_CODE = `repositories {
  mavenCentral()
}`;

export const ANDROID_SNIPPET_DEPENDENCY_CODE = `dependencies {
  implementation("pro.piwik:sdk-framework-android:VERSION")
}`;


interface AndroidInstallProps {
  app: App
  t: TFunction
  handleCopyToClipboard: (result: boolean, productAnalyticsActionType: string) => void
}

const AndroidInstall: React.FC<AndroidInstallProps> = ({
  app,
  t,
  handleCopyToClipboard,
}) => (
  <Stack vertical>
    <Stack.Item fill>
      <Stack vertical spacing="narrow">
        <Stack.Item>
          <Text as="p">
            <Trans
              i18nKey="apps.details.installation.android.new-instruction.line1"
              components={[
                <CodeInline dataId="TextStyle">Code</CodeInline>,
              ]}
            />
          </Text>
        </Stack.Item>
        <Stack.Item fill>
          <Stack fullWidth>
            <Stack.Item />
            <Stack.Item fill>
              <CodeSnippet
                code={ANDROID_SNIPPET_REPOSITORIES_CODE}
                onCopy={result => handleCopyToClipboard(
                  result,
                  PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES.ANDROID,
                )}
                mode="no-highlight"
              />
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Text as="p">
            <Trans
              i18nKey="apps.details.installation.android.new-instruction.line2"
              components={[
                <CodeInline dataId="TextStyle">Code</CodeInline>,
              ]}
            />
          </Text>
        </Stack.Item>
        <Stack.Item fill>
          <Stack fullWidth>
            <Stack.Item />
            <Stack.Item fill>
              <CodeSnippet
                code={ANDROID_SNIPPET_DEPENDENCY_CODE}
                onCopy={result => handleCopyToClipboard(
                  result,
                  PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES.ANDROID,
                )}
                mode="no-highlight"
              />
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack>
            <Stack.Item />
            <Stack.Item>
              <Text as="p" size={12} dataId="Caption" color="InkLighter">
                <Trans
                  i18nKey="apps.details.installation.android.instruction.line1.part2"
                  components={[
                    <CodeInline dataId="TextStyle">Code</CodeInline>,
                    <Link size="small" href="https://github.com/PiwikPRO/sdk-framework-android/releases">latest release</Link>,
                  ]}
                />
              </Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Text as="p">
            <Trans
              i18nKey="apps.details.installation.android.new-instruction.line3"
              components={[
                <Link href="https://developers.piwik.pro/en/latest/data_collection/mobile/Piwik_PRO_SDK_for_Android.html">Set up the SDK</Link>,
              ]}
            />
          </Text>
        </Stack.Item>
        <Stack.Item>
          <Text as="p">
            <Trans
              i18nKey="apps.details.installation.android.new-instruction.line4"
              components={[
                <Link href={`/analytics/#/${app.id}/settings/debugger/`}>tracker debugger</Link>,
              ]}
            />
          </Text>
        </Stack.Item>
      </Stack>
    </Stack.Item>
    <Stack.Item>
      <Text as="p">
        {t('apps.details.installation.instruction.help.part1')}
        <Link href="https://developers.piwik.pro/en/latest/integrations/Piwik_PRO_SDK_for_Android.html">
          {t('apps.details.installation.links.installGuide')}
        </Link>
        {t('apps.details.installation.instruction.help.part2')}
        <Link href="http://community.piwik.pro/">
          {t('apps.details.installation.links.community')}
        </Link>
        .
      </Text>
    </Stack.Item>
  </Stack>
);

export default AndroidInstall;
